import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { phoneValidation } from "../../utils/validations";
import { commonStyles } from "../../utils/styles/CommonStyle";
import { Theme } from "../../theme/Theme";
import CommonButton from "../../components/common/CommonButton";
import { useDispatch, useSelector } from "react-redux";
import { SendOtpActionInitiate } from "../../redux/actions/auth/sendOtpAction";
import { Loader } from "../../utils";
import AuthLayout from "../../components/common/AuthLayout";

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.sendOtp);
  const formik = useFormik({
    initialValues: { phone: "" },
    validationSchema: Yup.object({ phone: phoneValidation }),
    onSubmit: async (values) => {
      const cleanPhone = values.phone.replace(/^\+91\s?/, '');
      const payload = {
        phone_number: cleanPhone,
        is_forgotpassword: true
      }
      const result = await dispatch(SendOtpActionInitiate(payload));

      if (result?.success) {
        localStorage.setItem("auth_phone", cleanPhone);
        localStorage.setItem("auth_flow", "forgot_password");
        navigate("/verify-otp");
      }
    }
  });

  return (
    <AuthLayout
      title="Forgot Password?"
      subtitle="Don’t worry. We’ll help you recover it."
      showTabs={false}
      showLegalLinks={false}
    >
      <form className="w-100" autoComplete="off" onSubmit={formik.handleSubmit}>
        <input
          type="tel"
          name="phone"
          placeholder="Phone Number"
          autoComplete="tel"
          value={formik.values.phone}
          maxLength={10}
          onChange={(e) => {
            const val = e.target.value.replace(/[^0-9]/g, '').slice(0, 10);
            formik.setFieldValue("phone", val);
          }}
          onBlur={formik.handleBlur}
          onPaste={(e) => {
            e.preventDefault();
            const pasted = e.clipboardData.getData('text').replace(/[^0-9]/g, '').slice(0, 10);
            formik.setFieldValue("phone", pasted);
          }}
          style={{
            ...commonStyles.input,
            ...Theme.inputText,
            ...(formik.touched.phone && formik.errors.phone ? commonStyles.errorBorder : commonStyles.commonBorder)
          }}
        />
        {formik.touched.phone && formik.errors.phone && <div style={Theme.errorText}>{formik.errors.phone}</div>}

        <div className="d-flex justify-content-center mx-auto mb-2 w-100 mt-4">
          <CommonButton
            title={
              loading ? (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                  <Loader variant="dots" size="small" color="white" />
                  <span>Sending OTP...</span>
                </div>
              ) : "Send OTP"
            }
            type="submit"
            width={"100%"}
            disabled={loading}
          />
        </div>
      </form>
      <div style={{ width: "100%", marginTop: 60, textAlign: "center" }}>
        <span style={Theme.modalDescription}>Remembered your password?</span>
        <Link to="/" style={{ display: 'inline-block', width: '100%' }} className="text-decoration-none">
          <CommonButton title="Log In Now" onClick={() => { }} width="100%" variant="outline" />
        </Link>
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;
